import React from 'react';
import { Link } from '@stashinvest/ui/dist/es/2';
import { Link as AdvisoryLink } from '@stashinvest/ui';

const tooltipLink = (url, text, idx) => {
	return (
		<Link
			as="button"
			onClick={() => window.open(url, '_blank')}
			key={`interpolationToolTipLink_${idx}`}
		>
			{text}
		</Link>
	);
};

const advisoryLink = (url, text, idx) => {
	return (
		<AdvisoryLink
			href={url}
			target="_blank"
			rel="noreferrer"
			key={`interpolationAdvisoryLink_${idx}`}
		>
			{text}
		</AdvisoryLink>
	);
};

export const listOfInterpolationsToJSX = (
	str = '',
	interpolations,
	withAdvisoryLink = false
) => {
	const splitStrArray = str.split(/({{\S+}})/);
	if (interpolations?.length === 0 || splitStrArray.length < 3) {
		return str;
	}
	interpolations.forEach((interpolation) => {
		const keySubstr = '{{' + interpolation.key + '}}';
		splitStrArray.forEach((substr, idx) => {
			if (keySubstr === substr) {
				splitStrArray[idx] = withAdvisoryLink
					? advisoryLink(interpolation.url, interpolation.text, idx)
					: tooltipLink(interpolation.url, interpolation.text, idx);
			}
		});
	});
	return splitStrArray;
};
